import {Vue} from "ui.vue";
import CitrusIblockElement from "../components/form.vue";
import axios from 'axios';

/**
 * Класс конструктор для инициализации компонента
 */
class CitrusInitForm {

	/**
	 */
	constructor() {
		this.metricGoal = false;
		this.params = null;
		this.vueComponent = null;
		this.signedParameters = null;
		this.componentName = null;
	}

	/**
	 * Динамическое создание компонента
	 * @returns {Init}
	 */
	createForm(params) {
		this.params = params;
		this.vueComponent = CitrusIblockElement;

		this.setParams();

		Vue.create(this.vueComponent);
		return this;
	}

	/**
	 * Фиксируем параметры компонента
	 * @param params
	 */
	setSignedParameters(params) {
		this.signedParameters = params;
		return this;
	}

	/**
	 * Получаем параметры компонента
	 * @return params
	 */
	getSignedParameters() {
		return this.signedParameters;
	}

	/**
	 * Установка параметра компанента
	 */
	setParams() {
		this.vueComponent.el = '#' + this.params.templateId;

		let vueData = this.vueComponent.data();
		let newData = Object.assign(vueData, this.params);

		this.vueComponent.data = function () {
			return newData;
		};
		return this;
	}

	/**
	 * Подготовка данных с формы для отправки данных
	 *
	 * @param arFields
	 * @returns {[]}
	 */
	prepareFormData(arFields) {
		let result = [];
		let fields = Array.isArray(arFields) ? arFields : [];

		for (let value of fields) {
			if (value.GROUP_FIELD) {
				let resultGroups = this.prepareFormData(value.ITEMS);
				result = result.concat(resultGroups);
			} else {
				result.push(value);
			}
		}
		return result;
	}

	setComponentName(name = 'citrus.forms:iblock.element') {
		this.componentName = name;
		return this;
	}

	getComponentName() {
		return this.componentName;
	}

	/**
	 * Отправить данные на сервер
	 *
	 * @param arFields - массив с данными для отправки на сервер
	 * @param action - действие, как именно будет обрабатываться запрос
	 * @param options false|object // add additional headers, example: [{'name': 'If-Modified-Since', 'value': 'Wed, 15 Aug 2012 08:59:08 GMT'}, {'name': 'If-None-Match', 'value': '0'}]
	 * @returns {Promise}
	 */
	sendRequest(arFields, action = 'saveForm', options = {}) {
		let componentName = this.getComponentName();
		let data = this.prepareFormData(arFields);

		let formData = new FormData();

		formData.append('signedParameters', this.getSignedParameters());
		formData.append('sessid', BX.bitrix_sessid());
		if (BX.message.SITE_ID) {
			formData.append('SITE_ID', BX.message.SITE_ID);
		}

		for (let field of data) {
			if (field.MULTIPLE) {
				for (let fieldValueItem of field.VALUE) {
					formData.append(field.ID, fieldValueItem);
				}
			}
			else {
				formData.append(field.ID, field.VALUE);
			}
		}

		return new Promise((resolve, reject) => {
			axios.post("/bitrix/services/main/ajax.php?mode=class&c=" + componentName + "&action=" + action, formData, options).then((response) => {
				try {
					if (!response.hasOwnProperty("data")) {
						throw new Error("Data not found");
					}

					response = response.data; // у axios свой формат response
					let errors = response.hasOwnProperty("errors") && response.errors && Array.isArray(response.errors) && response.errors.length > 0 ? response.errors : false;
					if (errors) {
						throw new Error(errors[0].message);
					}

					if (!response.hasOwnProperty("status") || response.status != "success") {
						reject("Status error");
					}

					// отправим метрику
					if(this.metricGoal)
					{
						this.$metrika.reachGoal(this.metricGoal);
						this.$gtag.event(this.metricGoal);
					}

					resolve(response.data);
				} catch (e) {
					reject(e.message);
				}
			}).catch((error) => {
				console.error(error);
				reject(error);
			});
		});
	}
}

let InitForm;
InitForm = new CitrusInitForm();
export {InitForm};
